<template>
   <div class="container">
      <input type="file" @change="handleFileUpload" accept=".xls,.xlsx" />
      <!-- Display the table if there is data -->
      <div class="row">
         <div class="col-md-12">
            <table v-if="jsonData.length" border="1" class="table table-striped table-bordered">
               <thead>
                  <tr>
                     <th v-for="(header, index) in tableHeaders" :key="index">
                        {{ header }}
                     </th>
                  </tr>
               </thead>
               <tbody>
                  <tr v-for="(row, rowIndex) in jsonData" :key="rowIndex">
                     <td v-for="(value, colIndex) in row" :key="colIndex">
                        {{ value }}
                     </td>
                  </tr>
               </tbody>
            </table>
         </div>
      </div>
   </div>
</template>

<script>
export default {
   data() {
      return {
         jsonData: [],
         tableHeaders: [],
         structuredJson: "", // Pretty JSON output
      };
   },
   emits: ["excelLoaded"],
   methods: {
      handleFileUpload(event) {
         const file = event.target.files[0];
         if (!file) return;

         const reader = new FileReader();
         reader.onload = (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: "array" });

            // Get the first sheet
            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];

            // Convert to JSON
            // const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

            const jsonArray = XLSX.utils.sheet_to_json(worksheet);

            // Extract table headers
            if (jsonArray.length > 0) {
               this.tableHeaders = Object.keys(jsonArray[0]);
               this.jsonData = jsonArray;
               this.structuredJson = JSON.stringify(jsonArray, null, 2); // Pretty format
            }
            
            // format to snake case
            this.$emit("excelLoaded", this.structuredJson);
         };

         reader.readAsArrayBuffer(file);
      },
      toSnakeCase(str) {
         return str.replace(/\s+/g, '_').toLowerCase();
      }
   },
   mounted() {
      // Load XLSX from CDN dynamically
      const script = document.createElement("script");
      script.src = "https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.18.5/xlsx.full.min.js";
      script.onload = () => console.log("XLSX library loaded!");
      document.head.appendChild(script);
   },
};
</script>

<style>
.container {
   max-width: 80%;
   margin: 20px auto;
   text-align: center;
}
</style>